/** What a typical winning price test lifts revenue by (the middle of 4–7%). */
export const LIFT = 0.055;

export const formatDollars = (value: number) => `$${Math.round(value).toLocaleString('en-US')}`;

/** Extra revenue per month one winning test would add at this monthly revenue. */
export const monthlyLift = (revenue: number) => revenue * LIFT;
